<template>
  <div class="estrutura-item">
    <div class="item-name" :class="{ active: item.id == value }">
      <span @click="selected(item)" v-if="!editing">
        <font-awesome-icon icon="folder-open" class="mr-2" />
        <span>{{ item.nome }}</span>
      </span>

      <b-input-group v-else>
        <template #prepend>
          <font-awesome-icon icon="folder-open" class="mt-2 mr-2" />
        </template>
        <b-form-input
          size="sm"
          v-model="item.nome"
          ref="input_edit"
          @blur="saveItem"
        />
      </b-input-group>

      <div class="estrutura-actions ml-auto text-nowrap">
        <b-button
          variant="outline-info"
          size="sm"
          class="btn-action rounded-circle"
          @click="novoItem"
          ><font-awesome-icon icon="plus"
        /></b-button>
        <b-button
          variant="outline-exitos"
          size="sm"
          class="btn-action rounded-circle"
          @click="editItem"
          ><font-awesome-icon icon="edit"
        /></b-button>
        <b-button
          variant="outline-danger"
          size="sm"
          class="btn-action rounded-circle"
          @click="deleteItem"
          ><font-awesome-icon icon="trash-alt"
        /></b-button>
      </div>
    </div>

    <ul>
      <li v-for="(child, key) in children" :key="key">
        <item-estrutura v-model="local_value" :item="child" />
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "item-estrutura",
  props: {
    value: null,
    item: {
      type: Object,
      require: true,
    },
  },
  data: () => ({
    editing: false,
  }),
  computed: {
    ...mapState("files", ["estrutura"]),
    local_value: {
      set(value) {
        this.$emit("input", value);
      },
      get() {
        return this.value;
      },
    },
    children() {
      let itens = [];
      this.estrutura.forEach((element) => {
        if (element.file_folder_id === this.item.id) {
          itens.push(element);
        }
      });
      return itens;
    },
  },
  methods: {
    ...mapActions("files", [
      "ActionAddFilesEstrutura",
      "ActionSaveEstrutura",
      "ActionDeleteFilesEstrutura",
    ]),
    selected(item) {
      this.local_value = item.id;
    },
    editItem() {
      this.editing = true;
      this.$nextTick(() => {
        this.$refs.input_edit.focus();
      });
    },
    saveItem() {
      this.editing = false;
      this.ActionSaveEstrutura(this.item);
    },
    novoItem() {
      this.ActionAddFilesEstrutura({
        file_folder_id: this.item.id,
      });
    },
    deleteItem() {
      this.ActionDeleteFilesEstrutura(this.item.id);
    },
  },
  created() {
    if (!this.item.id) {
      this.editItem();
    }
  },
};
</script>

<style>
</style>
